import { Component, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { SamplesCheckoutSuccessComponent } from './samples-checkout-success.component';
export namespace NSamplesCheckoutSuccessCms {
    export const BLOCK_ID = 'cms-sampples-checkout-success';
    export type IBlockData = Catalog.IBlockData<IBlockDataContent>;
    export interface IBlockDataContent {
        mainTitle: string;
        subtitle: string;
        copy: string;
        continueButtonCopy: string;
        bottomComponents: NICmsContentComponent.IData[];
    }
}
@Component({
    selector: 'cms-samples-checkout-success',
    template: '<samples-checkout-success [content]="content"></samples-checkout-success>',
    standalone: true,
    imports: [SamplesCheckoutSuccessComponent]
})
@ICmsComponent<SamplesCheckoutSuccessCmsComponent>({
    id: NSamplesCheckoutSuccessCms.BLOCK_ID,
    block: {
        url: NSamplesCheckoutSuccessCms.BLOCK_ID,
    },
    onDemandOnly: true,
    name: 'Checkout success page layout',
    description: 'Checkout success page layout block',
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'mainTitle',
            title: 'Title',
            default: 'Thank You!',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'subtitle',
            title: 'Subtitle',
            default: 'What happens next?',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'copy',
            title: 'Copy',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'continueButtonCopy',
            title: 'Continue button copy',
            default: 'Continue shopping',
            required: true
        },
        <NICmsContentField.IComponentsField>{
            key: 'bottomComponents',
            type: NICmsContentField.EFieldType.components,
            title: 'Bottom components',
            itemName: 'component',
            default: []
        }
    ]
})
export class SamplesCheckoutSuccessCmsComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit, OnChanges, OnDestroy {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NSamplesCheckoutSuccessCms.IBlockDataContent;
    protected override canDetach = false;
}
